import { useNavigate } from "react-router-dom";
import "./style.css";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useMessage } from "../../global-components/src";
import Spinner from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { Clipboard, CreditCard, RefreshCw, Wallet as WalletIcon, QrCode as QrCodeIcon } from "lucide-react";
import { errorMessage } from "../../utils/TextManagerTwo";
import { formatCurrency } from "../../utils/numbers";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { logEvent } from "../../components/analytics-tracker";
import { PaymentTypes } from "../../global-components/src/types";
import { useTranslation } from 'react-i18next';

const Donate = () => {
    const [oldValue, setOldValue] = useState<string>(sessionStorage.getItem("oldValueDonate") || "");
    const [value, setValue] = useState<string>("");
    const [formatedAmount, setFormatedAmountformatedAmount] = useState<number>(0);
    const [errorsInput, setErrorsInput] = useState<{ amount?: string[] }>({});
    const { setMessage } = useMessage();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { token, user, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const [paymentMethod, setPaymentMethod] = useState<PaymentTypes>("wallet");
    const [walletBalance, setWalletBalance] = useState<number>(0);
    const [loadinWallet, setLoadingWallet] = useState<boolean>(true);
    const [copiado, setCopiado] = useState(false);
    const [loadingVerifyPayment, setLoadingVerifyPayment] = useState(false);
    const [qrCode, setQrCode] = useState<any>(() => {
        const savedQrCode = sessionStorage.getItem("qrCodeDonate");
        return savedQrCode ? savedQrCode : null;
    });
    const [copyPaste, setCopyPaste] = useState<string | null>(() => {
        const saved = sessionStorage.getItem("copyPasteDonate");
        return saved ? saved : null;
    });
    const [transaction, setTransaction] = useState<any>(() => {
        const saved = sessionStorage.getItem("transactionDonate");
        return saved ? JSON.parse(saved) : null;
    });

    useEffect(() => {
        if (qrCode) sessionStorage.setItem("qrCodeDonate", qrCode);
        if (copyPaste) sessionStorage.setItem("copyPasteDonate", copyPaste);
        if (transaction) sessionStorage.setItem("transactionDonate", JSON.stringify(transaction));
        if (formatedAmount && !qrCode) sessionStorage.setItem("oldValueDonate", String(formatedAmount));
    }, [qrCode, copyPaste, transaction, formatedAmount]);

    useEffect(() => {
        setLoadingWallet(true);
        if (!isAuthenticated) return;

        axios.get(`${PACOCA_API_URL}/wallet`, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(res => {
            setWalletBalance(Number(res.data.balance));
        }).finally(() => {
            setLoadingWallet(false);
        });
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (transaction?.gateway_txid) verifyPayment();
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    const verifyPayment = async (manual = false) => {
        if (manual) setLoadingVerifyPayment(true);
        if (!isAuthenticated) return;

        try {
            const response = await axios.post(`${PACOCA_API_URL}/donate/verify-payment`, {
                gateway_txid: transaction.gateway_txid,
            }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (response.data.status == "completed") {
                setMessage(`Doação efetuada`, "success");
                cancel();
                return;
            }

            if (manual) {
                setMessage(t("donate.notConfirmed"), "error");
            }

        } catch (err: any) {
            const messageError = errorMessage(err);

            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors);
            } else {
                setMessage(messageError, "error");
            }
            console.error(messageError);
            console.error(err);
        } finally {
            setLoadingVerifyPayment(false);
        }
    };

    const copyLink = async () => {
        if (!copyPaste) return;
        try {
            await navigator.clipboard.writeText(copyPaste);
            setCopiado(true);
            setTimeout(() => setCopiado(false), 2000);
        } catch (err) {
            console.error(err);
        }
    };

    const cancel = () => {
        setOldValue("");
        setValue("");
        setLoading(false);
        setQrCode(null);
        setCopyPaste(null);
        setTransaction(null);

        sessionStorage.removeItem("qrCodeDonate");
        sessionStorage.removeItem("copyPasteDonate");
        sessionStorage.removeItem("transactionDonate");
        sessionStorage.removeItem("oldValueDonate");
    };

    useEffect(() => {
        let valueFormmater = value;
        valueFormmater = valueFormmater.replace(/R\$\s*/g, '');
        valueFormmater = valueFormmater.replace(/\s+/g, '');
        valueFormmater = valueFormmater.replace(/\./g, '');
        valueFormmater = valueFormmater.replace(/,/g, '.');
        let valueNumber = Number(valueFormmater);
        setFormatedAmountformatedAmount(valueNumber);
    }, [value]);

    useEffect(() => {
        if (formatedAmount > walletBalance || !isAuthenticated) setPaymentMethod("gerencianet_pix");
    }, [formatedAmount, isAuthenticated]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(formatCurrency(event.target.value));
    };

    const submit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        setErrorsInput({});
        setMessage("", "error");
        setOldValue(value);

        try {
            let valueFormmater = value;
            valueFormmater = valueFormmater.replace(/R\$\s*/g, '');
            valueFormmater = valueFormmater.replace(/\s+/g, '');
            valueFormmater = valueFormmater.replace(/\./g, '');
            valueFormmater = valueFormmater.replace(/,/g, '.');
            let valueNumber = Number(valueFormmater);

            let errors: Record<string, string[]> = {};
            if (!valueNumber) {
                errors.amount = [t("errors.input.required", { field: t("generics.value") })];
            }
            if (valueNumber < 1) {
                errors.amount = [t("donate.minValue")];
            }

            if (Object.keys(errors).length > 0) {
                throw { response: { data: { errors } } };
            }

            logEvent("nova_doacao", {
                categoria: "Doação",
                acao: "Nova Doação",
            });
            const response = await axios.post(`${PACOCA_API_URL}/${isAuthenticated ? "" : "public/"}donate`, {
                amount: valueNumber, gateway: paymentMethod
            }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if (paymentMethod == "wallet") {
                setMessage(`Doação realizada`, "success");
                cancel();
                navigate(`/carteira`);
                return;
            }

            setTransaction(response.data.transaction);
            if (response.data.gateway_data?.qrcode) {
                setQrCode(response.data.gateway_data.qrcode);
                setCopyPaste(response.data.gateway_data.copyPaste);
            }
        } catch (err: any) {
            const messageError = errorMessage(err);

            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors);
            } else {
                setMessage(messageError, "error");
            }
            console.error(err);
        }
        setLoading(false);
    };

    return (
        <Screen paddingTopTitle={true} title="Doação">
            <Helmet>
                <title>Paçoca - Doação</title>
                <meta name="description" content={`Doação para o Paçoca, ajude a rede soocial 100% brasileira a manter suas despesas!`} />
                <meta name="keywords" content={`Paçoca, rede social brasileira, Doação, doe, precisa, ajudar brasileiro, ajuda, 100% brasileira, rede social, pagamento}`} />
                <meta name="author" content="Paçoca Inc." />
                <meta property="og:title" content={`Paçoca - Doação`} />
                <meta property="og:description" content={`Doação para o Paçoca, ajude a rede soocial 100% brasileira a manter suas despesas`} />
                <meta property="og:image" content="/img/link-preview.png?v=1" />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`Paçoca - Doação`} />
                <meta name="twitter:description" content={`Doação para o Paçoca, ajude a rede soocial 100% brasileira a manter suas despesas`} />
                <meta name="twitter:image" content="/img/link-preview.png?v=1" />
            </Helmet>

            <div className="padding-big-screen">
                <form className="bank-tx" onSubmit={submit}>
                    {!qrCode ? (
                        <>
                            <div className="bank-hero">
                                <h5 className="bank-hero-title">Ajude o PDRB</h5>
                                <p className="foc-qr-hint">
                                    Ajude o PDRB (Plano de dominação das redes brasileiras independentes)
                                    fazendo sua doação para manter o Paçoca no ar.
                                </p>
                            </div>

                            <div className="bank-amount-block">
                                <input
                                    type="text"
                                    value={value}
                                    onChange={handleChange}
                                    placeholder="0,00"
                                    className="bank-amount-input"
                                    autoFocus
                                />
                            </div>
                            {errorsInput.amount && (
                                <div role="alert" className="bank-error" style={{ textAlign: "center", marginTop: -10, marginBottom: 14 }}>
                                    {errorsInput.amount[0]}
                                </div>
                            )}

                            {isAuthenticated && (
                                <>
                                    <div className="bank-section-label">Forma de pagamento</div>
                                    <div className="foc-pay-list">
                                        <label
                                            className={`foc-pay-item ${paymentMethod === "wallet" ? "sel" : ""} ${formatedAmount > walletBalance ? "bank-pay-disabled" : ""}`}
                                        >
                                            <input
                                                type="radio"
                                                name="paymentMethod"
                                                className="sr-only"
                                                checked={paymentMethod === "wallet"}
                                                disabled={formatedAmount > walletBalance}
                                                onChange={() => setPaymentMethod("wallet")}
                                            />
                                            <span className={`bank-radio ${paymentMethod === "wallet" ? "bank-radio-sel" : ""}`} />
                                            <span className="bank-payment-icon">
                                                <WalletIcon size={16} />
                                            </span>
                                            <div>
                                                <div className="bank-pay-title">Saldo da carteira</div>
                                                <div className="bank-payment-sub">
                                                    {loadinWallet ? (
                                                        <span className="bank-placeholder-inline" />
                                                    ) : (
                                                        `Disponível: R$ ${walletBalance.toFixed(2).replace(".", ",")}`
                                                    )}
                                                </div>
                                            </div>
                                            {!loadinWallet && (
                                                <span className={`bank-pay-tag ${formatedAmount > walletBalance ? "bank-pay-tag-warn" : "bank-pay-tag-ok"}`}>
                                                    {formatedAmount > walletBalance ? "Saldo insuficiente" : "Disponível"}
                                                </span>
                                            )}
                                        </label>

                                        <label className={`foc-pay-item ${paymentMethod === "gerencianet_pix" ? "sel" : ""}`}>
                                            <input
                                                type="radio"
                                                name="paymentMethod"
                                                className="sr-only"
                                                checked={paymentMethod === "gerencianet_pix"}
                                                onChange={() => setPaymentMethod("gerencianet_pix")}
                                            />
                                            <span className={`bank-radio ${paymentMethod === "gerencianet_pix" ? "bank-radio-sel" : ""}`} />
                                            <span className="bank-payment-icon">
                                                <QrCodeIcon size={16} />
                                            </span>
                                            <div>
                                                <div className="bank-pay-title">Pix</div>
                                                <div className="bank-payment-sub">QR Code gerado após confirmar</div>
                                            </div>
                                        </label>
                                    </div>
                                </>
                            )}

                            <div className="foc-actions">
                                <button disabled={loading} type="submit" className="foc-btn foc-btn-primary">
                                    {loading ? (
                                        <Spinner size="20px" />
                                    ) : paymentMethod == "gerencianet_pix" ? (
                                        "Gerar Pix"
                                    ) : (
                                        t("donate.action")
                                    )}
                                </button>
                            </div>
                        </>
                    ) : null}

                    {qrCode ? (
                        <>
                            <div className="bank-qr-status">
                                <span className="bank-qr-status-dot" />
                                Aguardando pagamento
                            </div>

                            <p className="foc-qr-hint">
                                Escaneie o QR Code com o app do seu banco ou copie o código Pix abaixo.
                            </p>
                            <p className="foc-qr-hint">
                                R$ {oldValue}
                            </p>

                            <div className="bank-qr-wrap">
                                <img src={qrCode} width={220} className="bank-qr-img" alt="QR Code PIX" />
                            </div>

                            <div className="bank-qr-actions">
                                <button onClick={copyLink} type="button" className="foc-btn foc-btn-primary">
                                    <Clipboard size={15} />
                                    {copiado ? t("payment.copied") : t("payment.copyCode")}
                                </button>

                                {isAuthenticated && (
                                    <button
                                        disabled={loadingVerifyPayment}
                                        onClick={() => verifyPayment(true)}
                                        type="button"
                                        className="foc-btn foc-btn-primary"
                                    >
                                        {loadingVerifyPayment ? <Spinner size="20px" /> : <><RefreshCw size={15} /> Verificar</>}
                                    </button>
                                )}
                            </div>

                            <button onClick={cancel} type="button" className="bank-cancel-link">
                                Cancelar
                            </button>
                        </>
                    ) : null}
                </form>
            </div>
        </Screen>
    );
};

export default Donate;